/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

/**
 *
 * @namespace classes.EventHelper
 */
const EventHelper /** @lends classes.EventHelper*/ = {
  preventCancelableDefault: function (event) {
    if (typeof event.cancelable !== "boolean" || event.cancelable) {
      // The event can be canceled, so we do so.
      event.preventDefault();
      return true;
    }
    // The event cannot be canceled, so it is not safe
    // to call preventDefault() on it.
    console.warn("Event couldn't be canceled");
    return false;
  }
};

modulum("EventHelper", function (context, cls) {
  cls.EventHelper = EventHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = EventHelper;
}
